/* eslint-disable function-paren-newline */
/* eslint-disable quotes */
import Mark from 'mark.js';
import { openAllComments } from 'components/organisms/comment-list/comment-list';
import { openAccordionIfItemIsInside } from 'components/organisms/accordion/accordion';
import { t } from './withTranslation';

export default class ControlF {
  constructor($template) {
    this.$wrapper = document.querySelector('.page__content');
    // Selector names from typo3 module cTypes,
    // or add .js-searchable to any element to add it to the whitelist
    const whitelistSelectors = [
      '.js-searchable',
      // typo3 selectors
      '.article__section--text',
      '.article__section--list',
      '.article__section--rsmfaq_pi1',
      '.article__section--bwsociallinklist_pi1 ',
      '.article__section--bw_quote_teaser_pi1',
      '.tx-bw_textimageteaser_pi1',
      '.article__section--bw_textimageteaser_to38',
      '.article__section--menu_sitemap_pages',
      'div:not(.multibox) .contact-box',
      '.article__section--rsmtile_pi1',
      '.article__section--table',
      '.article__section--bw_imageteaser_pi2 ',
      // further css classes to include in search
      '.accordion',
      '.table',
      '.article-title',
      '.quote',
      '.hint',
      'div:not(.multibox) .list',
      '.dossier-header',
      '.page-text',
      '.slider',
      '.comment__text-full',
      '.comment-list__search-results',
    ];
    this.$searchables = document.querySelectorAll(whitelistSelectors.join(','));
    this.blacklist = ['noscript', 'script', 'iframe'];
    this.Marker = new Mark(this.$searchables);
    this.markedResults = [];
    this.currentIndex = 0;
    this.currentClass = 'control-f__current';
    this.urlParamKey = 'highlight';
    this.commentUrlParamKey = 'comment[highlight]';
    this.paramValue = new URLSearchParams(window.location.search).get(
      this.urlParamKey
    );
    this.commentParamValue = new URLSearchParams(window.location.search).get(
      this.commentUrlParamKey
    );

    this.bindedDeconstructor = this.deconstructor.bind(this);
    this.bindedHandleSearch = this.handleSearch.bind(this);
    this.bindedOnMarkWordsDone = this.onMarkWordsDone.bind(this);
    this.bindedHandleMark = this.handleMark.bind(this);
    this.bindedHandleNavigateMarks = this.handleNavigateMarks.bind(this);

    if ($template) {
      // add searchbox to DOM on ctrl F
      window.addEventListener('keydown', (e) => {
        if (
          e.code === 'F3' ||
          ((e.ctrlKey || e.metaKey) && e.code === 'KeyF')
        ) {
          e.preventDefault();
          const $clone = document.importNode($template.content, true);

          if (this.$wrapper) {
            this.$wrapper.appendChild($clone);
            this.initSideSearch();
          }
        }
      });
    }

    // if a param value is present onload, search for it and do not show the searchbox
    if (this.paramValue || this.commentParamValue) {
      this.bindedHandleSearch(true);
    }
  }

  /** initializes all DOM elements of the searchbox */
  initSideSearch() {
    this.$searchBox = document.querySelector('.control-f');
    if (this.$searchBox) {
      this.$close = this.$searchBox.querySelector('.control-f__close');
      this.$submit = this.$searchBox.querySelector('.control-f__submit');
      this.$input = this.$searchBox.querySelector('#control-f');
      this.$form = this.$searchBox.querySelector('.control-f__wrap');
      this.$label = this.$searchBox.querySelector('.label');
      this.$prev = this.$searchBox.querySelector('.control-f__btn--up');
      this.$next = this.$searchBox.querySelector('.control-f__btn--down');

      if (this.$input) {
        this.$input.focus();
        this.initEvents();
      }
    }
  }

  /** initializes all Events for the DOM elements of the searchbox */
  initEvents() {
    if (this.$close) {
      this.$close.addEventListener('click', this.bindedDeconstructor);
    }
    if (this.$submit) {
      this.$submit.addEventListener('click', this.bindedHandleSearch);
    }

    if (this.$form) {
      this.$form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.bindedHandleSearch();
      });
    }

    if (this.$prev && this.$next) {
      [this.$prev, this.$next].forEach(($btn, i) => {
        $btn.addEventListener('click', () =>
          this.bindedHandleNavigateMarks(i === 0)
        );
      });
    }
  }

  /** jumps to the mark that the currentIndex refers to */
  jumpTo() {
    if (this.markedResults.length) {
      const $current = this.markedResults.item(this.currentIndex);
      this.markedResults.forEach((result) => {
        result.classList.remove(this.currentClass);
      });
      if ($current) {
        $current.classList.add(this.currentClass);
        // fixes focus not set in sliders
        setTimeout(() => {
          $current.focus();

          $current.scrollIntoView();
        }, 200);
      }
    }
  }

  /** changes the currentIndex to the previous or next */
  handleNavigateMarks(isPrevButton) {
    if (this.markedResults.length) {
      this.currentIndex = isPrevButton
        ? this.currentIndex - 1
        : this.currentIndex + 1;

      if (this.currentIndex < 0) {
        this.currentIndex = this.markedResults.length - 1;
      }

      if (this.currentIndex >= this.markedResults.length) {
        this.currentIndex = 0;
      }
      this.jumpTo();
    }
  }

  /** Unmarks all marks and starts a new marking process */
  handleSearch(disableJumpTo = false) {
    this.Marker.unmark({
      done: () => this.bindedHandleMark(disableJumpTo),
    });
  }

  /** initializes the Marker with the current value (from search input or from URL param) */
  handleMark(disableJumpTo = false) {
    const value =
      this.$input && this.$input.value
        ? this.$input.value
        : this.paramValue || this.commentParamValue;
    if (value) {
      this.Marker.mark(value, {
        className: 'text-highlight',
        done: (totalMarks) =>
          this.bindedOnMarkWordsDone(totalMarks, disableJumpTo),
        separateWordSearch: false,
        exclude: this.blacklist,
      });
    }
  }

  /** After marking is done, show the navigation buttons (if searchbox is visible),
   * change the label to show the total number of marks found (if searchbox is visible),
   * prepare the found marks to be visible in accordions and sliders
   * and jump to the first mark.
   */
  onMarkWordsDone(totalMarks, disableJumpTo = false) {
    if (this.$input && this.$input.value) {
      if (this.$prev && this.$next) {
        [this.$prev, this.$next].forEach(($btn) => {
          $btn.classList.add('control-f__btn--visible');
        });
      }
    }

    if (this.$label) {
      this.$label.innerHTML = `${t('Suche')} (${totalMarks} ${t('Treffer')})`;
    }

    this.markedResults = document.querySelectorAll('mark');

    if (this.markedResults.length) {
      for (let i = 0; i < this.markedResults.length; i += 1) {
        const $result = this.markedResults.item(i);
        // Opens accordion if mark is inside a content item
        openAccordionIfItemIsInside($result);
        // Will enable sliders to scroll the marked caption into view
        $result.setAttribute('tabindex', '1');
        openAllComments();
      }
    }
    this.currentIndex = 0;
    if (!disableJumpTo) {
      this.jumpTo();
    }
  }

  /** Remove the searchbar from the DOM (if it exists) and unmark everything */
  deconstructor() {
    if (this.$searchBox) {
      this.$searchBox.remove();
    }
    this.Marker.unmark();
  }
}

document.querySelectorAll('.js-control-f').forEach(($template) => {
  // eslint-disable-next-line no-unused-vars
  const el = new ControlF($template);
});
